var _ellipse, _ellipse2, _polyline, _polyline2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "stroke-color-main",
    cx: 81.76,
    cy: 172.438,
    rx: 15.671,
    ry: 15.799
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "stroke-color-main",
    cx: 131.924,
    cy: 172.438,
    rx: 15.639,
    ry: 15.799
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "stroke-color-main",
    points: "56.518 133.144 153.347 133.144 190.523 60.246 166 60.246"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "stroke-color-main",
    points: "0.535 11.763 20.361 11.893 65.529 172.567"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 97.904,
    y1: 173.937,
    x2: 116.415,
    y2: 173.937
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 99.587,
    y1: 14,
    x2: 99.587,
    y2: 109.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 51.63,
    y1: 59.89,
    x2: 148.37,
    y2: 59.89
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/add_to_cart.d13ccc0d932c5e625d747d0a82acaee3.svg";
export { ForwardRef as ReactComponent };